import { Component } from '@angular/core';
import { NavController, NavParams, PopoverController, ToastController, AlertController } from 'ionic-angular';
import { DIC } from '../../../dic';
import { PopupPage } from '../../../popup/popup';
import { GN } from '../../../../gn';

/**
 * Generated class for the EditroutenumberingPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-editroutenumbering',
  templateUrl: 'editroutenumbering.html',
})
export class EditroutenumberingPage {
  data = []
  prefix = ''
  counter = 1
  counterlen = 4
  sufix = ''
  resetperiod = 'yearly'

  constructor(public navCtrl: NavController, public navParams: NavParams, public dic: DIC, public popoverCtrl: PopoverController, public gn: GN, public toastCtrl: ToastController, public alertCtrl: AlertController) {
    this.data = navParams.get('data')
    if (this.data.length > 0) {
      this.prefix = this.data[0].prefix
      this.counter = this.data[0].counter
      this.counterlen = this.data[0].counterlength
      this.sufix = this.data[0].sufix
      this.resetperiod = this.data[0].resetperiod
    }
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad WorkshifteditPage');
  }

  openResetPeriod(_ev) {
    var _that = this
    let popover = this.popoverCtrl.create(PopupPage, {
      type: 'rperiod', selected: 0, callback: function (_text, _ids) {
        _that.resetperiod = _ids
      }
    });
    popover.present({ ev: _ev });
  }

  isNumber(n) {
    return !isNaN(parseFloat(n)) && isFinite(n);
  }

  Save() {
    var _that = this
    if (!this.isNumber(this.counter)) {
      let toast = this.toastCtrl.create({
        message: _that.dic.l["enterIntCounter"],
        duration: 3000,
        position: 'top'
      });
      toast.present();
    }
    if (!this.isNumber(this.counterlen)) {
      let toast = this.toastCtrl.create({
        message: _that.dic.l["enterIntCounterLen"],
        duration: 3000,
        position: 'top'
      });
      toast.present();
    }

    var _dat = {
      cid: this.gn.crypt(this.gn.user.ClientId),
      prefix: this.gn.crypt(this.prefix),
      counter: this.gn.crypt(this.counter),
      counterlen: this.gn.crypt(this.counterlen),
      sufix: this.gn.crypt(this.sufix),
      resetperiod: this.gn.crypt(this.resetperiod)
    }

    // var check = 0;

    this.gn._Post('/api/gn/setRouteNumbering', _dat, function (_data) {
      var _cb = _that.navParams.get('cb')
      if (_cb != null) {
        _cb(_data)
      }
      var _msg = _that.dic.l["succNumbering"]
      let toast = _that.toastCtrl.create({
        message: _msg,
        duration: 3000,
        position: 'top'
      });
      toast.present();
      _that.navCtrl.pop()
    })
  }
}



// WEBPACK FOOTER //
// ./src/pages/settings/generalsettings/editroutenumbering/editroutenumbering.ts